import { render, staticRenderFns } from "./index.vue?vue&type=template&id=93d2fcae&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93d2fcae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2023/thShop/thShopAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93d2fcae')) {
      api.createRecord('93d2fcae', component.options)
    } else {
      api.reload('93d2fcae', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=93d2fcae&scoped=true&", function () {
      api.rerender('93d2fcae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/active/giftBatch/index.vue"
export default component.exports